import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = ["onSubmit"];
const _hoisted_2 = ["name", "value"];
import { object, string } from 'yup';
import { ValidationProvider, ValidationField, yupResolver } from '@/components/ui/validate-form';
import ValidationErrors from '@/components/ui/validation-errors.vue';
import { trlMessage } from '@/services/i18n';
import { UiButton, UiInput, UiStack } from '@huntflow/ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'profile-form',
    props: {
        defaultValues: {},
        loading: { type: Boolean, default: false },
        submitLabel: {}
    },
    emits: ["submit"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const formFields = [
            { id: 'first_name', label: trlMessage('profile.name') },
            { id: 'last_name', label: trlMessage('profile.last_name') },
            { id: 'company', label: trlMessage('profile.company') },
            { id: 'position', label: trlMessage('profile.position') },
            { id: 'email', label: trlMessage('profile.email') }
        ];
        const resolver = yupResolver(object({
            first_name: string().required(),
            last_name: string().required(),
            company: string().required(),
            position: string().required(),
            email: string().email().required()
        }));
        function onSubmit(values, context) {
            emit('submit', values, context);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ValidationProvider), {
                "default-values": __props.defaultValues,
                resolver: _unref(resolver),
                onSubmit: onSubmit
            }, {
                default: _withCtx(({ handleSubmit }) => [
                    _createElementVNode("form", {
                        method: "post",
                        class: _normalizeClass(_ctx.$style.form),
                        onSubmit: _withModifiers(handleSubmit, ["prevent"])
                    }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(formFields, (field, index) => {
                            return _createVNode(_unref(ValidationField), {
                                key: field.id,
                                name: field.id
                            }, {
                                default: _withCtx(({ modelValue, onChange, name, invalid }) => [
                                    _createVNode(_unref(UiStack), {
                                        gap: "xs",
                                        size: "full",
                                        direction: "column"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(UiInput), {
                                                id: field.id,
                                                title: field.label,
                                                error: invalid,
                                                name: name,
                                                autofocus: index === 0,
                                                "model-value": modelValue,
                                                size: "m",
                                                "onUpdate:modelValue": onChange
                                            }, null, 8, ["id", "title", "error", "name", "autofocus", "model-value", "onUpdate:modelValue"]),
                                            invalid
                                                ? (_openBlock(), _createBlock(ValidationErrors, {
                                                    key: 0,
                                                    name: field.id
                                                }, null, 8, ["name"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]),
                                _: 2
                            }, 1032, ["name"]);
                        }), 64)),
                        _createVNode(_unref(ValidationField), { name: "is_huntflow_client" }, {
                            default: _withCtx(({ modelValue, name }) => [
                                _createElementVNode("input", {
                                    type: "hidden",
                                    id: "is_huntflow_client",
                                    name: name,
                                    value: modelValue
                                }, null, 8, _hoisted_2)
                            ]),
                            _: 1
                        }),
                        _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style.submit)
                        }, [
                            _createVNode(_unref(UiButton), {
                                size: "xxl",
                                "html-type": "submit",
                                fill: "",
                                loading: __props.loading
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(__props.submitLabel), 1)
                                ]),
                                _: 1
                            }, 8, ["loading"])
                        ], 2)
                    ], 42, _hoisted_1)
                ]),
                _: 1
            }, 8, ["default-values", "resolver"]));
        };
    }
});
